"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function SET_CAROL_CAMPAIGN(state, data) {
    state.carolCampaign = data;
}
exports.SET_CAROL_CAMPAIGN = SET_CAROL_CAMPAIGN;
function SET_APRIL_CAMPAIGN(state, _a) {
    var campaignId = _a.campaignId, cruises = _a.cruises;
    state.aprilCampaigns[campaignId] = cruises;
}
exports.SET_APRIL_CAMPAIGN = SET_APRIL_CAMPAIGN;
function SET_FILTER(state, _a) {
    var key = _a.key, value = _a.value;
    state.filter[key] = value;
}
exports.SET_FILTER = SET_FILTER;
function SET_SORTBY(state, data) {
    state.sortBy = data;
}
exports.SET_SORTBY = SET_SORTBY;
function SET_SPECIAL_SORTBY(state, data) {
    state.specialSortBy = data;
}
exports.SET_SPECIAL_SORTBY = SET_SPECIAL_SORTBY;
function SET_AIRPORTS(state, airports) {
    state.availableAirports = lodash_1.concat(state.availableAirports, airports);
}
exports.SET_AIRPORTS = SET_AIRPORTS;
function SET_REGIONS(state, regions) {
    state.availableRegions = lodash_1.concat(state.availableRegions, regions);
}
exports.SET_REGIONS = SET_REGIONS;
function SET_RESULTS(state, routes) {
    state.searchResults = routes;
}
exports.SET_RESULTS = SET_RESULTS;
function SET_SHIPS(state, ships) {
    state.availableShips = lodash_1.concat(state.availableShips, ships);
}
exports.SET_SHIPS = SET_SHIPS;
function SET_SPECIAL_RESULTS(state, _a) {
    var routes = _a.routes, code = _a.code;
    if (!state.specialResults[code]) {
        state.specialResults[code] = routes;
        return;
    }
    state.specialResults[code] = lodash_1.concat(state.specialResults[code], routes);
    // console.log('SET_SPECIAL_RESULTS', state.specialResults[code])
}
exports.SET_SPECIAL_RESULTS = SET_SPECIAL_RESULTS;
function SET_NUMBER_CRUISES(state, value) {
    state.numberCruises = value;
}
exports.SET_NUMBER_CRUISES = SET_NUMBER_CRUISES;
function REMOVE_RESULTS(state) {
    state.searchResults = [];
}
exports.REMOVE_RESULTS = REMOVE_RESULTS;
function SET_CURRENT_PAGE(state, page) {
    state.paging.currentPage = page;
}
exports.SET_CURRENT_PAGE = SET_CURRENT_PAGE;
function RESET_STATE(state) {
    state.carolCampaign = {
        campaignEnd: null,
        campaignStart: null,
        campaignTeaserPricesStart: null,
        contentSections: null,
        contentSectionsHeadline: null,
        createdAt: null,
        description: null,
        descriptionHtml: null,
        headerImage: null,
        headline: null,
        id: null,
        specialOffers: [],
        subHeadline: null,
        tariffInformationHeadline: null,
        tariffInformationDescription: null,
        tariffInformationDescriptionHtml: null,
        teaserImage: null,
        updatedAt: null,
    };
    state.aprilCampaigns = {};
    state.filter = {
        depGermany: false,
        flightIncluded: false,
        priceModel: state.filter.priceModel,
        airport: null,
        region: null,
        shipCode: null,
        travelDuration: 9999,
        timeFrom: null,
        timeTo: null,
        cruises: [],
    };
    state.sortBy = {
        code: 'price',
        name: 'Preis',
        shortName: 'Preis',
    };
    state.specialSortBy = {
        code: 'date',
        name: 'Datum',
        shortName: 'Datum',
    };
    state.searchResults = [];
    state.specialResults = {};
    state.numberCruises = 0;
    state.availableAirports = [];
    state.availableRegions = [];
    state.availableShips = [];
    state.paging = {
        itemsPerPage: state.config.numberPages ? state.config.numberPages : 15,
        currentPage: 1,
    };
}
exports.RESET_STATE = RESET_STATE;
// export everything compliant to the vuex specification for getters
exports.default = {
    SET_CAROL_CAMPAIGN: SET_CAROL_CAMPAIGN,
    SET_APRIL_CAMPAIGN: SET_APRIL_CAMPAIGN,
    SET_FILTER: SET_FILTER,
    SET_SORTBY: SET_SORTBY,
    SET_SPECIAL_SORTBY: SET_SPECIAL_SORTBY,
    SET_AIRPORTS: SET_AIRPORTS,
    SET_REGIONS: SET_REGIONS,
    SET_RESULTS: SET_RESULTS,
    SET_SHIPS: SET_SHIPS,
    SET_NUMBER_CRUISES: SET_NUMBER_CRUISES,
    SET_SPECIAL_RESULTS: SET_SPECIAL_RESULTS,
    SET_CURRENT_PAGE: SET_CURRENT_PAGE,
    REMOVE_RESULTS: REMOVE_RESULTS,
    RESET_STATE: RESET_STATE,
};
//# sourceMappingURL=mutations.js.map